import mapFunction from './mapResources';

export default mapFunction('orders', {
    isFetching: false,
    items: [] 
});
